window.groupLogsByDay = function(){
	var last_date = "";
	$('.js-day-title').each(function(){
		if($(this).attr('data-date') == last_date){
			$(this).remove();
		} else {
			last_date = $(this).attr('data-date');
		}
	})
}